// Day js
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
// Translation
import i18n from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next, useTranslation } from "react-i18next";
// React
import { useEffect } from "react";
// React router dom
import { Route, Routes, useLocation, useNavigationType } from "react-router-dom";
// Pages
import Home from "./pages/Home/Home";
import Calendar from "./pages/CalendarPage/CalendarPage";
import InProgress from "./pages/InProgress/InProgress";
import ErrorPage from "./pages/Error/Error";
// Implementation Guide
import { toPublicUrl } from "./services/PublicUrl";
import ImplementationGuidePage from "./pages/ImplementationGuide/ImplementationGuidePage";

require('dayjs/locale/fr');

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['fr', 'en'],
    backend: {
      loadPath: toPublicUrl("/locales/{{lng}}/{{ns}}.json"),
    },
  })

dayjs.extend(relativeTime);
dayjs.locale(i18n.language);

function App() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  useTranslation();

  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    let title = "";
    let metaDescription = "";

    switch (pathname) {
      case "/":
      case "/Application":
      case "/Home":
      case "/Application/Home":
        title = "Home page";
        metaDescription = "";
        break;
      case "/Page":
        title = "page";
        metaDescription = "";
        break;
      case "/ImplementationGuide":
      case "/Application/ImplementationGuide":
        title = "FHIR Implementation Guide";
        metaDescription = "";
        break;
    }

    if (title) {
      document.title = title;
    }

    if (metaDescription) {
      const metaDescriptionTag: HTMLMetaElement | null = document.querySelector(
        'head > meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname]);

  return (
    <Routes>
      <Route index element={<Home />} />
      <Route
        path="/"
        element={<Home />}
      />
      <Route
        path="/Home"
        element={<Home />}
      />
      <Route
        path="/Application"
        element={<Home />}
      />
      <Route
        path="/Application/Home"
        element={<Home />}
      />
      <Route
        path="/Calendar"
        element={<Calendar />}
      />
      <Route path="/InProgress" element={<InProgress />} />
      <Route path="/Error" element={<ErrorPage />} />
      <Route
        path="/ImplementationGuide"
        element={<ImplementationGuidePage />}
      />
      <Route path="*" element={<ErrorPage notFound />} />
    </Routes>
  );
}

export default App;
